import { render } from "./Detail.vue?vue&type=template&id=65573fb5&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=65573fb5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65573fb5"

export default script